import React from "react";
import { Link } from "react-scroll";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import Logo from "./Logo";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-brand">
          <Logo className="brand--footer" />
          <p>
            Ndërtojmë produkte moderne web dhe mobile për biznese që duan të
            rriten me besim, cilësi dhe prani të fortë dixhitale.
          </p>
        </div>

        <div className="footer-links">
          <h4>Kompania</h4>
          <ul>
            <li>
              <Link to="home" smooth={true} duration={500} offset={-96}>
                Kryefaqja
              </Link>
            </li>
            <li>
              <Link to="services" smooth={true} duration={500} offset={-96}>
                Shërbimet
              </Link>
            </li>
            <li>
              <Link to="approach" smooth={true} duration={500} offset={-96}>
                Qasja
              </Link>
            </li>
            <li>
              <Link to="team" smooth={true} duration={500} offset={-96}>
                Ekipi
              </Link>
            </li>
            <li>
              <Link to="projects" smooth={true} duration={500} offset={-96}>
                Punët
              </Link>
            </li>
            <li>
              <Link to="contact" smooth={true} duration={500} offset={-96}>
                Kontakt
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Zgjidhje</h4>
          <ul>
            <li>Faqe & Aplikacione Web</li>
            <li>App Mobile iOS & Android</li>
            <li>Inteligjencë Artificiale (AI)</li>
            <li>Dizajn UI / UX</li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Ligjor</h4>
          <ul>
            <li>
              <Link
                to="privacy-policy"
                smooth={true}
                duration={500}
                offset={-96}
              >
                Politika e privatësisë
              </Link>
            </li>
            <li>
              <Link to="terms" smooth={true} duration={500} offset={-96}>
                Kushtet e shërbimit
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-social">
          <h4>Na ndiqni</h4>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/techtalentt"
              target="_blank"
              rel="noreferrer"
              aria-label="TechTalent në Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/_techtalent_ks/"
              target="_blank"
              rel="noreferrer"
              aria-label="TechTalent në Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} TechTalent. Të gjitha të drejtat e
          rezervuara.
          <span className="footer-bottom-sep" aria-hidden="true">
            {" "}
            ·{" "}
          </span>
          <span className="footer-bottom-note">
            Shërbime profesionale sipas marrëveshjeve me shkrim.
          </span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
